// extracted by mini-css-extract-plugin
module.exports = {"basicButton":"basic_basicButton__GG17p","textLink":"basic_textLink__10nJ2","heading":"basic_heading__3phpC","textButton":"basic_textButton__3mR87"};